<!-- <div fxLayout='column' fxFlexAlign='center bottom' class='footer' fxLayoutGap='0.2rem'>
    <span>2024 &#64;Stellantis. Powered by L3 ADAS. Build and Maintained by Stellantis </span>
</div>  -->

<!-- <footer fxLayout='column' fxFlexAlign='center bottom' class='footer' fxLayoutGap='0.2rem'>
    2024 &#64;Stellantis. Powered by L3 ADAS. Build and Maintained by Stellantis
</footer> -->


<div class="footer">
    <span>&copy;2025 Stellantis. All Rights Reserved.</span>
</div> 